import React, { Fragment, useEffect, useState } from "react";
// import { logindata } from "../../services/login"; // Keeping commented out as per original
import { useNavigate, useParams } from "react-router-dom";
import dotracking from "../trackinglogs";
import trackobj from "../trackingpages.json";

export const HomeKerala = () => {
    const [user, setUser] = useState("");
    const [pass, setPass] = useState("");
    const [submitted, setSubmitted] = useState(false);

    const [errorMsg, setErrorMsg] = useState("");
    const navigate = useNavigate();

    useEffect(() => {
        captcha();
    }, []);

    function fpass() {
        dotracking(
            "forgot your password link in school login $$ " + trackobj.forgotheading
        );
        navigate("/forgotusername");
    }

    function checkreg() {
        dotracking("New school registration link clicked $$ " + "G form link page");
        window.open("https://docs.google.com/forms/d/1lFviIhEShQQnbkOi9OVQHSk0N9TDpYyo4Og6fXyUjq0/viewform?edit_requested=true&fbzx=-7879443409425852235", "_blank");
    }

    const [capvalue, setCapvalue] = useState("");
    const [ecapvalue, setECapvalue] = useState("");

    function captcha() {
        setCapvalue("");
        var a = Math.ceil(Math.random() * 10) + "";
        var b = Math.ceil(Math.random() * 10) + "";
        var c = Math.ceil(Math.random() * 10) + "";
        var d = Math.ceil(Math.random() * 10) + "";
        var e = Math.ceil(Math.random() * 10) + "";
        var f = Math.ceil(Math.random() * 10) + "";
        var g = Math.ceil(Math.random() * 10) + "";
        setCapvalue(a + "" + b + "" + c + "" + d + "" + e + "" + f + "" + g);
    }

    const handleChange = (e) => {
        const regex = /^[0-9\b]+$/;
        if (e.target.value === "" || regex.test(e.target.value)) {
            setECapvalue(e.target.value);
        }
    };

    return (
        <Fragment>
            <div id="loginpage" className="app sidebar-mini rtl">
                <main className="md-overflow-hidden">
                    <div className="container">
                        <div className="row h-95">
                            <div className="col-md-6 pe-0 tab-100 order_a mob-100">
                                <div className="side slideup ">
                                    {/* LEFT PANEL: Updated Logos and Text */}
                                    <div className="img-top text-center">
                                        {/* 1. Vth Kerala Central Schools Sports Meet 2025-26 Logo */}
                                        <img
                                            src={require("../../assets/images/kerala/sportsmeet.jpeg")} // Assuming "sportsmeet.jpg" is the logo
                                            alt="Vth Kerala State Central Schools Sports Meet 2025-26"
                                            className="tagline_logo"
                                        />
                                        <h2 style={{ paddingLeft: '40px', color: '#fff' }}>
                                            Vth Kerala Central Schools Sports Meet 2025- 26
                                        </h2>
                                    </div>
                                    <article className="text-center text-white" >
                                        <p style={{ fontSize: '1rem' }}>
                                            As per the directive of the Ministry of Sports, Govt. of Kerala.
                                        </p>
                                        <p style={{ fontSize: '1rem' }}>
                                            Under the aegis of the
                                            <br />
                                            <img
                                                src={require("../../assets/images/kerala/statesports.jpeg")}
                                                alt="Kerala State Sports Council"
                                                className="kerala_logo"
                                            />
                                        </p>
                                        <p style={{ fontWeight: 'bold' }}>
                                            For Central Syllabus schools: CBSE, ICSE, KVS AND JNVs
                                        </p>
                                        <p >
                                            Supported by the
                                            <img
                                                src={require("../../assets/images/kerala/cbsecouncil.jpeg")}
                                                alt="Council of CBSE Schools Kerala"
                                                className="kerala_logo"

                                                style={{ margin: "10px", maxWidth: '50%', height: '150px' }}
                                            />
                                        </p>

                                    </article>

                                    <div className="social">
                                        <span>Follow Us</span>
                                        <a
                                            href="https://www.facebook.com/SportzVillage/"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            <i className="fa-brands fa-facebook-f"></i>
                                        </a>
                                        <a
                                            href="https://www.youtube.com/@sportzvillage7534"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            <i className="fa-brands fa-youtube"></i>
                                        </a>
                                        <a
                                            href="https://www.linkedin.com/company/sportz-village/"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            <i className="fa-brands fa-linkedin"></i>
                                        </a>
                                        <a href="https://twitter.com/sportzvillage" target="_blank" rel="noopener noreferrer">
                                            <i className="fa-brands fa-twitter"></i>
                                        </a>
                                    </div>
                                </div>
                                <div className="border-b slideup"></div>
                            </div>
                            <div className="col-md-6 ps-0 tab-100 mob-100">
                                <div className="slidedown border-t"></div>
                                <div className="form slidedown">
                                    <div className="form-text login">
                                        <h2 style={{ color: '#c40c26' }}>
                                            Sports Meet 2025- 26 Registration
                                        </h2>
                                        <h4 style={{ marginTop: '10px' }}>For Existing Schools</h4>
                                    </div>

                                    <form method="post" id="loginform" className="login">
                                        <div className="input-field">
                                            <label>
                                                <i className="fa-solid fa-user"></i>Username
                                            </label>

                                            <input
                                                type="text"
                                                id="mail-email"
                                                placeholder="Enter School ID/Username" // Adjusted placeholder
                                                required
                                                value={user}
                                                onChange={(e) => setUser(e.target.value)}
                                            />
                                            {submitted && !user && (
                                                <span className="text-danger">
                                                    Username is required
                                                </span>
                                            )}
                                        </div>

                                        <div className="input-field delay-100ms">
                                            <label>
                                                <i className="fa-solid fa-lock"></i>Password
                                            </label>
                                            <input
                                                type="Password"
                                                id="password"
                                                placeholder="Enter Password"
                                                value={pass}
                                                onChange={(e) => setPass(e.target.value)}
                                            />
                                            {submitted && !pass && (
                                                <span className="text-danger">
                                                    Password is required
                                                </span>
                                            )}
                                        </div>

                                        <div className="captcha-box">
                                            <div className="row">
                                                <div className="col-md-5">
                                                    <input
                                                        type="text"
                                                        value={capvalue}
                                                        readOnly
                                                        className="captcha-two"
                                                    />
                                                </div>
                                                <div className="col-md-2 text-center captcha-refresh">
                                                    <a
                                                        onClick={captcha}
                                                        className="fa fa-fw fa-refresh refresh captcha-refresh"
                                                        aria-hidden="true"
                                                    ></a>
                                                </div>
                                                <div className="col-md-5">
                                                    <input
                                                        type="text"
                                                        className="captcha-two"
                                                        placeholder="Enter The Captcha"
                                                        maxLength={12}
                                                        autoComplete="off"
                                                        value={ecapvalue}
                                                        onChange={handleChange}
                                                        onPaste={(e) => {
                                                            e.preventDefault();
                                                            return false;
                                                        }}
                                                        onCopy={(e) => {
                                                            e.preventDefault();
                                                            return false;
                                                        }}
                                                    />
                                                    {submitted && !ecapvalue && (
                                                        <span className="text-danger">
                                                            Captcha is required
                                                        </span>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                        {errorMsg !== "" && (
                                            <span className="text-danger">{errorMsg}</span>
                                        )}

                                        <button
                                            className="form-btn login"
                                            id="login"
                                            type="button"
                                        // onClick={submitlogin} // Keeping commented out
                                        >
                                            <span>Log In</span>
                                        </button>
                                    </form>

                                    <div className="con-text login">
                                        <p className="mt-4">
                                            <a onClick={fpass}>
                                                Forgot your <strong>password?</strong>
                                            </a>
                                        </p>
                                    </div>
                                    <hr />

                                    <div className="con-text regis">
                                        {/* 8. For new schools - link that with the g form */}
                                        <p className="mt-2 mb-0">
                                            **For New Schools:**{" "}
                                            <strong>
                                                <a onClick={checkreg}>Click Here to Register (G-Form)</a>
                                            </strong>
                                        </p>
                                    </div>
                                    <div style={{ textAlign: 'center', marginBottom: '20px' }}>
                                        <p style={{ margin: '0 0 5px 0', fontWeight: 'bold', color: '#666' }}>
                                            Technical Partner
                                        </p>
                                        <a href="http://pathwayz.sportzvillage.com/" target="_blank" rel="noopener noreferrer">
                                            <img
                                                src={require("../../assets/images/logo_sv.png")}
                                                alt="Sportz Village Logo"
                                                style={{ margin: "auto", height: '40px' }}
                                            />
                                        </a>

                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </main>
            </div>
        </Fragment>
    );
};